import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-tea-cup",
  "use": "icon-si-glyph-tea-cup-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-tea-cup\" id=\"icon-si-glyph-tea-cup\"><title>885</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(0.000000, 2.000000)\" fill=\"#434343\"><rect x=\"0\" y=\"0\" width=\"11.968\" height=\"1.976\" class=\"si-glyph-fill\" /><path d=\"M9.469,11.935 L2.54,11.935 C0.06,11.935 0.02,9.5 0.02,9.5 L0.02,3.042 L11.988,3.042 L11.988,9.389 C11.988,9.389 11.949,11.935 9.469,11.935 L9.469,11.935 Z\" class=\"si-glyph-fill\" /><path d=\"M12.887,2.035 L12.01,2.035 L12.01,3.937 C12.688,3.937 14.105,3.562 14.105,5.098 L14.105,5.876 C14.105,7.025 13.376,7.082 12.01,7.082 L12.01,8.941 L12.887,8.941 C14.596,8.941 15.979,7.85 15.979,6.505 L15.979,4.468 C15.979,3.125 14.596,2.035 12.887,2.035 L12.887,2.035 Z\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-tea-cup.svg
// module id = iO71
// module chunks = 62